const React = require('react');
const { default: TextField } = require('@mui/material/TextField');
const { default: MenuItem } = require('@mui/material/MenuItem');
const { default: ArrowDropDownIcon } = require('@mui/icons-material/ArrowDropDown');
const { default: Styled, css } = require('styled-components');
const { singleLineFieldStyles } = require('./singleLineFieldStyles');
const DropdownOptionStyles = require('./dropdownOptionStyles');
const OptionUtils = require('./options');

const internals = {};

module.exports = function ControlledSelectField(props) {

    const { SingleLineSelectField, StyledMenuItem } = internals;

    const {
        id,
        label,
        value,
        options = [],
        onBlur,
        onChange,
        onFocus,
        renderOption,
        renderValue,
        style,
        textFieldProps = {}
    } = props;
    const textFieldInputLabelProps = textFieldProps.InputLabelProps || {};
    const textFieldSelectProps = textFieldProps.SelectProps || {};
    const menuProps = DropdownOptionStyles.mergeLimitedMenuProps(
        textFieldSelectProps.MenuProps || {},
        DropdownOptionStyles.getVisibleMenuItemCount(options)
    );
    const menuListProps = menuProps.MenuListProps || {};
    const selectProps = {
        IconComponent: ArrowDropDownIcon,
        ...textFieldSelectProps,
        ...(textFieldInputLabelProps.id && !textFieldSelectProps.labelId ? { labelId: textFieldInputLabelProps.id } : {}),
        inputProps: {
            ...(textFieldProps.inputProps || {}),
            ...(textFieldSelectProps.inputProps || {})
        },
        MenuProps: {
            ...menuProps,
            variant: menuProps.variant || 'menu',
            anchorOrigin: menuProps.anchorOrigin || {
                vertical: 'bottom',
                horizontal: 'left'
            },
            transformOrigin: menuProps.transformOrigin || {
                vertical: 'top',
                horizontal: 'left'
            },
            MenuListProps: {
                ...menuListProps,
                sx: {
                    ...(menuListProps.sx || {}),
                    outline: 'none'
                }
            }
        }
    };

    const getSelectedLabel = (selectedValue) => {

        const selectedOption = options.find((option) => {

            const optionValue = OptionUtils.getOptionValue(option);

            return optionValue === selectedValue || String(optionValue) === String(selectedValue);
        });

        if (selectedOption) {
            return OptionUtils.getOptionLabel(selectedOption);
        }

        return selectedValue;
    };

    if (typeof renderValue === 'function') {
        selectProps.renderValue = renderValue;
    }
    else {
        selectProps.renderValue = (selectedValue) => {

            if (Array.isArray(selectedValue)) {
                return selectedValue.map(getSelectedLabel).join(', ');
            }

            return getSelectedLabel(selectedValue);
        };
    }

    return <SingleLineSelectField
        id={id}
        label={label}
        value={value ?? ''}
        onBlur={onBlur}
        onChange={(event) => {

            if (typeof onChange === 'function') {
                onChange(event.target.value, event);
            }
        }}
        onFocus={onFocus}
        select
        fullWidth
        style={style}
        {...textFieldProps}
        SelectProps={selectProps}
        $fieldStyles={textFieldProps.fieldStyles}
    >
        {options.map((option) => {

            const optionValue = OptionUtils.getOptionValue(option);
            const optionLabel = OptionUtils.getOptionLabel(option);
            const isSpecifyOption = optionValue === '__specify__'
                || String(optionLabel || '').toLowerCase().includes('specify below');

            return <StyledMenuItem
                key={optionValue || optionLabel}
                value={optionValue}
                data-specify-option={isSpecifyOption ? 'true' : undefined}
            >
                {typeof renderOption === 'function'
                    ? renderOption(option)
                    : optionLabel}
            </StyledMenuItem>;
        })}
    </SingleLineSelectField>;
};

internals.SingleLineSelectField = Styled(TextField)`
    ${singleLineFieldStyles}
    ${({ $fieldStyles }) => css`${$fieldStyles || ''}`}
`;

internals.StyledMenuItem = Styled(MenuItem)`
    ${DropdownOptionStyles.option}
    ${DropdownOptionStyles.specifyOption}
`;
